// Also a script command.
// unknownTarget:nameOfTarget
export default function unknownTarget(target) {
  this.write(`You don't see ${target} anywhere.`);
};